import { currency } from "@/lib/format";
import { cn } from "@/lib/utils";

export function DeltaPill({
  value,
  formatMoney,
}: {
  value: number;
  formatMoney?: boolean;
}) {
  const isPositive = value > 0;
  const display = formatMoney
    ? `${value >= 0 ? "+" : ""}${currency(Math.abs(value))}`
    : `${value >= 0 ? "+" : ""}${value}`;

  return (
    <span
      className={cn(
        "rounded-full px-2 py-1 text-[10px] font-bold",
        isPositive
          ? "bg-green-100 text-green-700 dark:bg-green-950/50 dark:text-green-400"
          : "bg-muted text-muted-foreground"
      )}
    >
      {display}
    </span>
  );
}
